<template>
  <div>
    <div
      id="select-connect-modal"
      class="modal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content bg-theme-39">
          <a
            data-dismiss="modal"
            href="javascript:;"
            @click="cancelConnectModalForm"
            class="absolute right-4 top-3 text-gray-500"
          >
            </a>
          <div class="modal-header">
            <h3 class="text-theme-1 font-semibold text-md">
              เลือกข้อมูลจากระบบอื่น
            </h3>
          </div>
          <div class="modal-body p-6">
            <div class="bg-white rounded-md p-4">
              <div v-if="dataNotFound" class="text-center text-red-600 p-2 mb-4 border border-red-600 rounded-md bg-red-100">
                ⚠️ ไม่พบข้อมูลจากระบบ {{systemNameText}}
              </div>
              <div class="mt-2" style="justify-self: center;">
                <div class="m-1" v-for="info in infoToBeSelect" :key="info.field">
                  <button 
                    class='t-tooltip btn btn-primary mb-2 w-full' 
                    @click="sendDataViaStore(info.field)"
                  >
                    <span class="t-tooltip-text">{{info.label}}</span>{{info.externalData}}
                  </button>
                </div>
              </div>

              <hr class="col-span-12 mt-4" />
              <div class="col-span-12 flex items-center mt-4 justify-end">
                <button
                  class="btn btn-primary ml-2"
                  data-dismiss="modal"
                  @click="cancelConnectModalForm"
                >
                  ปิด
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { Buffer } from 'buffer';
import { useBoraData } from '@/utils/useBoraData';
const { getPersonInfoFromBora } = useBoraData();
import solutionList from "@/data/solution_list.json"

const store = useStore();
const generateLogoHTML = ref("");
const cancelData = ref(false);
const openModalStatus = ref(false);
const connect_name = ref("CSG");
const img_connect_logo = ref("");
const national_id = ref("1234567890123");
const dataNotFound = ref(false);
const systemNameText = ref("");
const csg_data = ref();
const infoToBeSelect = ref([
  {
    field: "CSG",
    label: "ระบบเงินอุดหนุนเพื่อการเลี้ยงดูเด็กแรกเกิด กรมกิจการเด็กและเยาวชน",
    externalData: "ข้อมูลจาก ระบบเงินอุดหนุนเพื่อการเลี้ยงดูเด็กแรกเกิด (CSG)",
  },
  {
    field: "BORA",
    label: "ข้อมูลทะเบียนราษฎร์ กรมการปกครอง ผ่าน Linkage Center 2.0 (สป.พม.)",
    externalData: "ข้อมูลจาก ทะเบียนราษฎร์ กรมการปกครอง",
  }
]);
const props = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  memberData: Object,
});
const bora_data = ref({});
const tableRowHighlightStyle = computed(() => ({
  "background-color": "#dd9090",
}));
// const cancelConnectModalForm = async () => {
//   cancelData.value = true;
//   openModalStatus.value = false;
//   // ปิด modal
//   cash("#select-connect-modal").modal("hide");
// };
const cancelConnectModalForm = async () => {
  cancelData.value = true;
  openModalStatus.value = false;
  dataNotFound.value = false;
  // ปิด modal (ถ้าใช้ Tailwind/Bootstrap)
  // cash("#select-connect-modal").modal("hide"); 
};

const openConnectModal = async () => {
  openModalStatus.value = true;
  cancelData.value = false;
  dataNotFound.value = false;
};
const isObjectEmpty = (obj) => {
    // ตรวจสอบ null, undefined หรือ Object ที่ไม่มี key
    if (!obj) return true;
    if (obj.constructor !== Object) return false;
    const keys = Object.keys(obj);
    if (keys.length === 0) return true;
    // ถ้ามีแค่ flag เช่น { csg: true } หรือ { bora: true } ให้ถือว่าไม่มีข้อมูลจริง
    if (keys.length === 1 && (keys[0] === 'csg' || keys[0] === 'bora')) {
      return true;
    }
    return false;
};
const selectMSOData = (systemName) => {
  console.log(`เลือกใช้ข้อมูลเดิมแทนข้อมูลจาก ${systemName}`);
  cancelConnectModalForm();
};

const selectExternalData = (systemName) => {
  console.log(`เลือกใช้ข้อมูลจาก ${systemName}`);
  cancelConnectModalForm();
};
const system_data_selected = ref(null);
const decode = async (string) => {
  return Buffer.from(string, 'base64').toString('utf8');
}
const sendDataViaStore = async (systemName) => {
  if(systemName == 'CSG'){
  console.log(props.memberData)
   const config = {//1149901588313
                      url: `https://mso-logbook.m-society.go.th/api/dc/csg/v1?queryCode=MSO&EQC_IDCARD=${props.memberData?.national_id}`,
                    method: "GET",
                    headers:{
                        Authorization: `Bearer -69dn6ubuq7ln5q6qj0gjsgfcdgvw7yyzwubwa76sc1nol61oq`
                    }
                }
                await axios(config) 
                .then((res)=>{
                  const row = res?.data?.rows?.[0] || null;
                  console.log(row)
                  console.log(row && !isObjectEmpty(row))
                  if (row && !isObjectEmpty(row)) {
                    csg_data.value = row;
                    dataNotFound.value = false;
                  } else {
                    csg_data.value = {};
                    dataNotFound.value = true;
                  }
                }).catch((error)=>{
                  console.log(error);
                  csg_data.value = {};
                  dataNotFound.value = true;
                })
  }else if(systemName == 'BORA'){
    const pid = props.memberData?.national_id || "";
    if (!pid) {
      swalCustom.fire({
        text: "ไม่พบเลขบัตรประชาชนของสมาชิกสำหรับตรวจสอบกับทะเบียนราษฎร์",
        icon: "warning",
        confirmButtonText: "ปิด",
      });
      bora_data.value = {};
      dataNotFound.value = true;
      return;
    }
    bora_data.value = Object.freeze(await getPersonInfoFromBora(pid));
    if (bora_data.value && !isObjectEmpty(bora_data.value)) {
  dataNotFound.value = false
    }else{
  dataNotFound.value = true
    }
}
// const csg_data = ref({
// "EQ_GID_REGISTER":"พมจ.",
// "EQ_GID":"นครปฐม",
// "STATUS":"ได้รับเงิน",

// "EQC_CODE_PRENAME":"เด็กหญิง",
// "EQC_FIRSTNAME":"ณัฐนิชา",
// "EQC_LASTNAME":"ทด",
// "EQC_BIRTH_DATE":"2025-10-30T00:00:00.000Z",
// "EQ_FATHER_IDCARD":"1131313131315",
// "EQ_CODE_FATHER_PRENAME":"นาย",
// "EQ_FATHER_NAME":"ทนง ทด",
// "EQ_FATHER_NATIONALITY":"ไทย",
// "EQ_MOTHER_IDCARD":"1271271271123",
// "EQ_CODE_MOTHER_PRENAME":"นาง",
// "EQ_MOTHER_NAME":"ทนาง ทด",
// "EQ_MOTHER_NATIONALITY":"ไทย",
// "EQ_REGISTER_TYPE":"ผู้ปกครอง",

// "EQ_IDCARD":"2345678901234",
// "EQ_CODE_PRENAME":"ผู้ปกครอง",
// "EQ_FIRSTNAME":"ชื่อผู้ปกครอง",
// "EQ_LASTNAME":"สกุลผู้ปกครอง",
// "EQ_BIRTH_DATE":"2025-10-30T00:00:00.000Z",
// "EQ_NATIONALITY":"ไทย",
// "csg_status":"เด็กไม่อยู่ในพื้นที่"
// });

  // dataNotFound.value = false;
  let dataToSend = null;
  console.log(systemName)
  if (systemName === 'CSG') {
    systemNameText.value = 'CSG'
    csg_data.value.csg = true;
    dataToSend = csg_data.value;
  } else if (systemName === 'BORA') {
    systemNameText.value = 'ทะเบียนราษฎร์';
    dataToSend = { ...bora_data.value, bora: true };
  }
    system_data_selected.value = null;
  
  if (dataToSend && !isObjectEmpty(dataToSend)) {
    store.dispatch('main/updateExternalData', {
      system: systemName,
      data: dataToSend
    });
    system_data_selected.value = systemName;
  cash("#select-connect-modal").modal("hide");
  } else {
     store.dispatch('main/updateExternalData', {
      system: system_data_selected.value,
      data: dataToSend
    });
  }
};

const generateLogo = async () => {
  img_connect_logo.value = `<img class="connection-tags" src="${require("@/assets/images/logo/CSG.png")}">`;
};

onMounted(() => {
  generateLogo();
});
</script>

<style></style>
